import { Injectable } from '@angular/core';

// Internal services
import { BaseHttpService } from '../base-http-service.service';
import { AuthInterceptorService } from 'src/app/interceptors/auth.interceptor';

// Internal models
import { CurrentVenueISOTimeResponse } from 'src/app/models/venue/responses/current-venue-iso-time.response';

@Injectable({
  providedIn: 'root'
})
export class VenueService extends BaseHttpService {
  constructor(authInterceptor: AuthInterceptorService) {
    super(authInterceptor);
  }

  // ! POST Requests
  
  
  // ! GET Requests
  async getCorporationDetails(corporationDetailId: string, retry = true): Promise<any | null> {
    const endpoint = `/spotlite-proxy/SpotliteReservations/PublicCorporationDetails?cid=${corporationDetailId}`;
    return this.get<any>(endpoint, retry);
  }

  async getCorporationBranding(corporationDetailId: string, retry = true): Promise<any | null> {
    const endpoint = `/spotlite-proxy/SpotliteReservations/CorporationBranding?cid=${corporationDetailId}`;
    return this.get<any>(endpoint, retry);
  }

  async getVenueCurrentISOTime(corporationUserId: string, retry = true): Promise<CurrentVenueISOTimeResponse | null> {
    const endpoint = `/spotlite-proxy/SpotliteReservations/GetVenueCurrentISOTime?cuid=${corporationUserId}`;
    return this.get<any>(endpoint, retry);
  }
  async getVenueCurrentISOTimeByCorpDetailId(corporationDetailId: string, retry = true): Promise<CurrentVenueISOTimeResponse | null> {
    const endpoint = `/spotlite-proxy/SpotliteReservations/VenueCurrentISOTimeById?cid=${corporationDetailId}`;
    return this.get<any>(endpoint, retry);
  }
  // ! PUT Requests
  
  
}